import React, { useState, useEffect } from 'react';
import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import PaymentForm from './PaymentForm';
import { baseURL } from '../Redux/baseURL';


// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe('pk_test_51NGMrNJbg8KVoBIgjeuaTVpii9yWn0DTLka1oGL0jnUFn3sLCyFfhF7fOiCwFyN8elqSQJe1SQXQvp7Szd8vw25i00cjOfVWXm');

export default function StripeComponent() {
  const [ secret, setSecret ] = useState("");
  useEffect(() => {
    getSecret();
  }, [])
  // get userSecret
  const getSecret = async () => {
    fetch(baseURL + "/stripe/payment", {
      method: "POST",
      body: JSON.stringify({}),
      headers: {
        "Content-Type": "application/json"
      }
    }).then(resp => resp.json())
    .then(resp => {
      setSecret(resp.clientSecret);
      localStorage.setItem("secret", resp.clientSecret);
      console.log("secret", secret);
      console.log("resp", resp.clientSecret);
    })
  }
  console.log("secret", secret);
  const options = {
    // passing the client secret obtained in step 3
    clientSecret: secret,
    // Fully customizable with appearance API.
    appearance: {/*...*/},
  };

  return (
    <>
      <div className='main_head' style={{display: "flex", justifyContent: "center"}}>
        {stripePromise && secret && (
          <Elements stripe={stripePromise} options={options}>
            <PaymentForm />
          </Elements>
        )}
      </div>
    </>
  );
};